/**
 * List of organisation admins shown before disabling.
 */

import React from 'react';
import { Segment, Header, List, Message } from 'semantic-ui-react';
import { I18n, Translate } from 'react-redux-i18n';
import { OrgAdmin } from '../types';
import { i18nKeys } from '../constants';
import styles from '../DisableOrganization.module.css';

interface OrgAdminsListProps {
  admins: OrgAdmin[];
  /** Total admin count from the API, or `null` if it failed to load. */
  totalCount: number | null;
}

const adminName = (admin: OrgAdmin): string => {
  const name = [admin.firstName, admin.lastName].filter(Boolean).join(' ').trim();
  return name || I18n.t(i18nKeys.ADMINS.UNNAMED);
};

const OrgAdminsList: React.FC<OrgAdminsListProps> = ({ admins, totalCount }) => (
  <Segment className={styles.detailsSegment}>
    <Header as="h4">
      <Translate value={i18nKeys.ADMINS.TITLE} />{' '}
      ({totalCount === null ? I18n.t(i18nKeys.IMPACT.UNAVAILABLE) : totalCount})
    </Header>
    {totalCount === null ? (
      <Message warning>
        <Translate value={i18nKeys.ADMINS.LOAD_FAILED} />
      </Message>
    ) : totalCount === 0 ? (
      <Message info>
        <Translate value={i18nKeys.ADMINS.NONE} />
      </Message>
    ) : (
      <>
        <List divided relaxed className={styles.adminsList}>
          {admins.map((admin, index) => (
            <List.Item key={admin.id ?? admin.email ?? index}>
              <List.Content>
                <List.Header>{adminName(admin)}</List.Header>
                {admin.email && (
                  <List.Description className={styles.adminEmail}>
                    {admin.email}
                  </List.Description>
                )}
              </List.Content>
            </List.Item>
          ))}
        </List>
        {totalCount > admins.length && (
          <p className={styles.adminEmail}>
            {I18n.t(i18nKeys.ADMINS.SHOWING_SOME, {
              shown: admins.length,
              total: totalCount
            })}
          </p>
        )}
      </>
    )}
  </Segment>
);

export default OrgAdminsList;
